import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import channelImg from '../assets/images/04channel-img.png';
import channelTxt from '../assets/images/04channel-txt.png';
import bgImg from '../assets/images/bg-guide01.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { withUrlValidation } from '../components/withUrlValidation';

const FadeInBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 100vw;
  height: 100dvh;
  min-height: 100dvh;
  background: ${({ isFadingOut }) => isFadingOut ? '#000' : `url(${bgImg}) center/cover no-repeat`};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.5s ease, background 1.5s ease;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

const ChannelImg = styled.img<{ visible: number }>`
  width: 80vw;
  max-width: 600px;
  margin-top: 25dvh;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.2s;
`;

const ChannelTxt = styled.img<{ visible: number }>`
  width: 60vw;
  max-width: 500px;
  margin-top: 5dvh;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.2s;
`;

const BlackOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible'].includes(prop)
})<{ visible: boolean }>`
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: #000;
  opacity: ${({ visible }) => visible ? 1 : 0};
  pointer-events: none;
  transition: opacity 1.5s;
  z-index: 10;
`;

const ChannelOpenPage = () => {
  const [bgVisible, setBgVisible] = useState(0);
  const [imgVisible, setImgVisible] = useState(0);
  const [txtVisible, setTxtVisible] = useState(0);
  const [showBlack, setShowBlack] = useState(false);

  useEffect(() => {
    const bgTimer = setTimeout(() => setBgVisible(1), 100);
    const imgTimer = setTimeout(() => setImgVisible(1), 700);
    const txtTimer = setTimeout(() => setTxtVisible(1), 1500);
    let fadeOutTimer: NodeJS.Timeout | null = null;
    return () => {
      clearTimeout(bgTimer);
      clearTimeout(imgTimer);
      clearTimeout(txtTimer);
      if (fadeOutTimer) clearTimeout(fadeOutTimer);
    };
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (txtVisible) {
      const timer = setTimeout(() => setShowBlack(true), 3000);
      return () => clearTimeout(timer);
    }
  }, [txtVisible]);

  useEffect(() => {
    if (showBlack) {
      const timer = setTimeout(() => {
        // 현재 URL의 검색 파라미터를 유지하여 다음 페이지로 이동
        const searchParams = location.search;
        navigate(`/tale-house${searchParams}`);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [showBlack, navigate, location.search]);

  return (
    <FadeInBackground visible={bgVisible} isFadingOut={false}>
      <ChannelImg src={channelImg} alt="채널 오픈" visible={imgVisible} />
      <ChannelTxt src={channelTxt} alt="채널 오픈 텍스트" visible={txtVisible} />
      <BlackOverlay visible={showBlack} />
    </FadeInBackground>
  );
};

export default withUrlValidation(ChannelOpenPage, {
  requireValidation: true,
  showCountdown: true
}); 